// extracted by mini-css-extract-plugin
module.exports = {"borderedFooter":"FeaturedCommentsContainer-borderedFooter-d795f905ee83071c05b77b131401ba00"};